module.exports = "<div ui-view></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/baseData/goodsContrast/view/goodsContrastTemplate.html
// module id = VwSo
// module chunks = 0